import { LoaderFnConfig } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

export const BetColumnLoader: LoaderFnConfig = {
    id: 'bet-column',
    loaderFn: () => import('./bet-column.feature'),
    product: ClientConfigProductName.SPORTS,
};
